import {Image, Typography} from 'antd';
import {useGetInsuranceProvidersQuery} from "../../../store/states/InsuranceProvidersState";
import {InsuranceProviderEclaim} from "../../../models/InsuranceProvider";
import {getLogoFromIntegrationCode} from "../logoUtils";
import {useLogoBlob} from "./useLogoBlob";

export interface InfoLogoProps{
    organizationId:number|undefined
    width?:number
    height?:number
}

export function InfoLogo(props:InfoLogoProps){
    const {data: insuranceProviders} = useGetInsuranceProvidersQuery([]);
    const { Text } = Typography;

    const insuranceProvider: InsuranceProviderEclaim | null =
        insuranceProviders?.find((el: InsuranceProviderEclaim) => props.organizationId === el.id) ?? null;

    const {blobUrl, failed} = useLogoBlob(insuranceProvider?.id, insuranceProvider?.hasLogo);

    if (!insuranceProvider) {
        return <></>;
    }

    if (blobUrl) {
        return (
            <div className="logo-container">
                <img
                    src={blobUrl}
                    width={props.width}
                    height={props.height}
                    alt=""
                    style={{ objectFit: 'contain' }}
                />
            </div>
        );
    }

    if (!failed) {
        return <></>;
    }

    const fallbackSrc = getLogoFromIntegrationCode(insuranceProvider.integrationCode);

    return (
        <div className="logo-container">
            {fallbackSrc !== ""
                ? <Image src={fallbackSrc} preview={false} width={props.width} height={props.height} />
                : <Text strong>{insuranceProvider.description}</Text>
            }
        </div>
    );
}
